import { EcommerceConfig } from 'idt-ecommerce-api/config/config.models';
import { ContinentStoresConfig } from 'idt-ecommerce-api/stores/stores.models';


export enum DeviceType {
  MOBILE,
  TABLET,
  DESKTOP,
  DESKTOP_WIDE
}

export interface BreakPoint {
  bp: string;
  name: string;
  device: DeviceType[];
}

export interface StaticMaterializedConfig {
  staticMaterializedUrl: string;
  staticMaterializedUrlChina: string;
}

export interface ExperimentalFeatures {
  gmapsApiKey?: string;
  sduiPageType?: boolean;
  resizeObserverInSliceSlider?: boolean;
  activityCenter?: boolean;
  translateByL10N?: boolean;
}

export interface LocalFontSource {
  name: string;
  path: string;
  fontWeight?: string;
  fontStyle?: string;
}

export interface FontsConfig {
  sources: LocalFontSource[];
  domains: {
    default: string;
    [countryCode: string]: string;
  };
}

export interface PageType {
  name: string;
  label: string;
}

export interface SPAConfiguration {
  apiEcommerceBaseUrl: string;
  isProduction: boolean;
  amandaImageVideoManagerEnabled: boolean;
  staticMaterializedConfig?: StaticMaterializedConfig;
  assetsUrl: string;
  ecommerce: EcommerceConfig;
  breakpoints: BreakPoint[];
  storesGroup?: ContinentStoresConfig[];
  experimentalFeatures?: ExperimentalFeatures;
  fonts?: FontsConfig;
  pageTypes?: PageType[];
  hasToLockNewConfigurations?: boolean;
}
